import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil';
import { clinicState } from '../../globalState';
import ObgynScreening from '../../components/screenings/obgynScreening/ObgynScreening'
import styles from './Screening.module.scss';
import Loader from '../../components/Loader/Loader';
import GdsScreening from '../../components/screenings/gdsScreening/GdsScreening';
import Phq9Gad7Screening from '../../components/screenings/phq9Gad7Screening/Phq9Gad7Screening';
import LunajoyObgynScreening from '../../components/screenings/lunajoyScreening/lunajoyObgynScreening/LunajoyObgynScreening';
import LunajoyPhq9Gad7Screening from '../../components/screenings/lunajoyScreening/lunajoyPhq9Gad7Screening/LunajoyPhq9Gad7Screening';
import Phq2Gad2Screening from '../../components/screenings/phq2Gad2Screening/Phq2Gad2Screening';
import LunajoyPhq2Gad2Screening from '../../components/screenings/lunajoyScreening/lunajoyPhq2Gad2Screening/LunajoyPhq2Gad2Screening';
import { LunaJoyFoundationService } from '../../services/LunajoyFoundationService'
import generateHeadText from '../../utilities/generateHeadText';
import Background from '../../components/Background/Background';
import EMRDirectScreening from '../../components/screenings/EMRScreening/EMRDirectScreening';
import { useTranslation } from 'react-i18next';

const Screening = () => {
  const { slug, direct } = useParams()
  const [{ clinic, error }, setClinic] = useRecoilState(clinicState)

  // multilingual text
  const { t } = useTranslation()
  const errorTitle = t('errorTitle')

  const loadClinic = useCallback(async () => {
    try {
      const currentSlug = slug
      
      // Known screening types that can appear at the end of slugs
      const knownScreeningTypes = ['phq9-gad7', 'phq2-gad2', 'obgyn', 'gds', 'direct']
      
      // Extract clinic code by removing the screening type from the end
      let clinicCode = currentSlug
      for (const screeningType of knownScreeningTypes) {
        if (currentSlug.endsWith(`-${screeningType}`)) {
          clinicCode = currentSlug.slice(0, -(screeningType.length + 1)) // +1 for the hyphen
          break
        }
      }

      const clinicInfo = await LunaJoyFoundationService.getClinicByCode(clinicCode)
      const clinicSpecialty = clinicInfo?.clinicGHLTags?.find(tag => tag.type === 'Specialty')?.value?.trim() || ''

      let matchingScreening = {}
      if (direct) {
        matchingScreening['type'] = direct;
      } else {
        const clinicScreeningSlugs = Object.entries(clinicInfo.screeningSlugs)
        if (clinicScreeningSlugs.length > 0) {
          for (const [type, slug] of clinicScreeningSlugs) {
            if (slug === currentSlug) {
              matchingScreening['type'] = type;
              matchingScreening['screeningName'] = slug;
            }
          }
        } else {
          matchingScreening['type'] = 'phq9-gad7';
          matchingScreening['screeningName'] = currentSlug;
        }
      }
      const clinic = { ...clinicInfo, matchedScreening: matchingScreening, clinicSpecialty }
      setClinic({ clinic, error: null })
      document.title = generateHeadText(clinic).title
    } catch (error) {
      console.log(error)
      setClinic({ clinic: null, error: 'Not Found' })
    }
  }, [slug])

  useEffect(() => {
    if (slug) {
      loadClinic()
    }
  }, [slug])

  if (error || !slug) return (
    <main>
      <Background clinicDetails={null}>
        <div className={styles.container}>
          <h1 className={styles.screeningHeader}>{errorTitle}</h1>
        </div></Background>
    </main>
  )

  if (!clinic) return (
    <main>
      <Background clinicDetails={null}>
        <div className={styles.container}>
          <h1 className={styles.screeningHeader}><Loader /></h1>
        </div>
      </Background>
    </main>
  )

  return (
    <main>

      {
        clinic.name === 'Lunajoy' && clinic.matchedScreening.type === 'obgyn'
          ? <LunajoyObgynScreening />
          : clinic.name === 'Lunajoy' && clinic.matchedScreening.type === 'phq9-gad7'
            ? <LunajoyPhq9Gad7Screening />
            : clinic.name === 'Lunajoy' && clinic.matchedScreening.type === 'phq2-gad2'
              ? <LunajoyPhq2Gad2Screening />
              : clinic.matchedScreening.type === 'obgyn'
                ? <ObgynScreening />
                : clinic.matchedScreening.type === 'gds'
                  ? <GdsScreening />
                  : clinic.matchedScreening.type === 'phq9-gad7'
                    ? <Phq9Gad7Screening />
                    : clinic.matchedScreening.type === 'phq2-gad2'
                      ? <Phq2Gad2Screening />
                      : clinic.matchedScreening.type === 'direct'
                        ? <EMRDirectScreening screeningType='phq9-gad7' />
                        : <h1 className={styles.screeningHeader}>Sorry, this screening is not available</h1>
      }

    </main>
  )
}

export default Screening